<template>
  <div
    class="skeleton-card"
    :style="skeletonRootStyle"
  >
    <SkeletonItem
      v-for="line in 6"
      :key="line"
      class="skeleton-line"
      :style="{ borderRadius: '8px' }"
      :animated="true"
    />
  </div>
</template>

<script lang="ts" setup>
  import { SkeletonItem } from '@experience/core-skeleton-lib';
  import { computed } from 'vue';

  const props = withDefaults(
    defineProps<{
      /**
       * Высота блока превью (как у заменяемой карточки). Задаётся с родителя,
       * чтобы совпадать с контейнером изображения под текущий брейкпоинт.
       */
      imageHeight: string;
    }>(),
    {
      imageHeight: '287px',
    },
  );

  const skeletonRootStyle = computed(() => {
    return {
      '--journal-card-skeleton-image-height': props.imageHeight,
    };
  });
</script>

<style lang="scss" scoped>
  .skeleton-line {
    height: 20px;
    margin-top: 8px;

    &:nth-child(1) {
      width: 100%;
      height: var(--journal-card-skeleton-image-height);
      margin-top: 0;
    }

    &:nth-child(2) {
      width: 90%;
      margin-top: 16px;
    }

    &:nth-child(3) {
      width: 100%;
    }

    &:nth-child(4) {
      width: 50%;
    }

    &:nth-child(5) {
      width: 60%;
      height: 14px;
    }

    &:nth-child(6) {
      width: 50%;
      height: 14px;
    }
  }
</style>
